export const SET_ORDERS = 'setOrders'
export const APPEND_ORDERS = 'appendOrders'
export const SET_ORDERS_LOADING = 'setOrdersLoading'
